//this is going to be our javelina client library we use in any service that needs to make these calls
const axios = require('axios').default;
const axiosRetry = require('axios-retry');
const API_URL = process.env.JAVELINA_PROXY_API_URL || null;
const API_KEY = process.env.JAVELINA_PROXY_API_KEY || null;
const constants = require('../constants.json');
axios.defaults.timeout = 30000;

/************* Config *************/
const loadConstants = () => {
    return constants
}

const axiosRetryInstance = axios.create({ baseURL: API_URL });

axiosRetry(axiosRetryInstance, {
    retries: 5,
    retryCondition: (error) => error && error.response && error.response.status === 500,
});

/************* Helpers *************/

/**
 * @param {*} apiKey 
 * @param {*} extraHeaders 
 */
const generateHeaders = (apiKey = null, extraHeaders = {}) => {
    if (apiKey == null) {
        apiKey = API_KEY;
    }
    return {
        'x-api-key': apiKey,
        'content-type': 'application/json',
        'connection': 'keep-alive',
        ...extraHeaders
    }
}

/**
 * @param {*} jvMemberDetails 
 * @param {*} dob 
 * @param {*} fName 
 * @param {*} lName 
 * @param {*} meta 
 */
const verifyJvMember = async (jvMemberDetails, dob, fName, lName, meta) => {
    for (let memberDet of jvMemberDetails) {
        if (memberDet.PatientFirstName.toLowerCase() === fName.toLowerCase() &&
            memberDet.PatientLastName.toLowerCase() === lName.toLowerCase() &&
            memberDet.BirthDate === dob) {
            return { Response: memberDet, MetaData: meta }
        }
    }
    return null
}

/**
 * @param {*} params 
 * @param {*} path 
 */
const queryParamsToPathParams = (params, path) => {
    if (params != null) {
        for (let key of Object.keys(params)) {
            if (params[key]) {
                path += `/${key}/${params[key]}`
            }
        }
    }
    return path;
}

const loopPagenationResults = async (key, response) => {
    let results = [];
    if (response == null || response.Response == null || response.Response[key] == null ||
        response.Response[key].length < 1) {
        return results;
    }

    results.push(...response.Response[key]);
    if (response.Response.Pagination != null && response.Response.Pagination.Next != null) {
        const splitNextArray = response.Response.Pagination.Next.split('/');
        const indexOfRest = splitNextArray.indexOf('rest') + 1;
        let url = `${API_URL}pureProxy`;
        for (let i = indexOfRest; i < splitNextArray.length; i++) {
            url += `/${splitNextArray[i]}`;
        }

        const newResponse = await axios.get(url, {
            headers: generateHeaders()
        });
        if (newResponse.status !== 200) {
            return null;
        }
        response = newResponse.data;
        results.push(...(await loopPagenationResults(key, response)));
    }
    return results;
}

module.exports = {
    axios,
    axiosRetryInstance,
    API_URL,
    API_KEY,
    loadConstants,
    generateHeaders,
    verifyJvMember,
    queryParamsToPathParams,
    loopPagenationResults
}